import { Box, Stack, Typography, Button, useTheme, Select, alpha, MenuItem, InputLabel, FormControl, OutlinedInput } from "@mui/material";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { NumbericInputCustom, SelectCustom } from "../../components/FormElements";
import { ToggleIcon, ToggleActiveIcon } from "../../components/IconComponent";
import { cache } from "../../utils/cache";
import { formatAmount, replaceParamTranslation } from "../../utils/util";
import validators from "../../utils/validators";
import { GetIconColor } from "../../theme/main_style";
import AlertComponent from "../../components/Alert";

export default function WalletAllowanceView2(props) {
    const { t } = useTranslation();
    const { palette } = useTheme();

    const { wallet_sharing, showCommercePools, showMaximumAmount, readOnly, defaultValues, message } = props;
    const currency = cache.getCurrency();
    const appConfig = cache.getAppConfig();
    const commercePools = appConfig && appConfig.features && appConfig.features.contact && appConfig.features.contact.finance && appConfig.features.contact.finance.transfer && appConfig.features.contact.finance.transfer.commerce_pools ? appConfig.features.contact.finance.transfer.commerce_pools : []

    let accessLevel = [
        { label: t('access_level_restricted'), value: "RESTRICTED_ACCESS" },
        { label: t('access_level_full'), value: "FULL_ACCESS" }
    ]

    let iconColor = readOnly ? GetIconColor().default : GetIconColor().primary

    let _commercePools = '';
    if (wallet_sharing && wallet_sharing.commerce_pools && wallet_sharing.commerce_pools.length > 0) {
        if (wallet_sharing.commerce_pools.length == 1) {
            _commercePools = wallet_sharing.commerce_pools[0].name
        } else {
            wallet_sharing.commerce_pools.forEach((item, index) => {
                let isLastItem = wallet_sharing.commerce_pools.length - 1 == index;
                _commercePools += item.name + (isLastItem ? '.' : ', ');
            });
        }
    }
    return (
        <>
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit }) => (
                <Box sx={{maxHeight:window.innerHeight - 200, overflowY: 'auto'}}>

                    <Box mt={1} paddingX={2} mb={1} width={'100%'} borderRadius={2} border={'1px solid'} borderColor={palette.border.main}>
                        <Typography variant="body1" fontWeight={'bold'} marginTop={2} marginBottom={1} display='flex' justifyContent={'center'}>{t('wallet_allowance')}</Typography>

                        {!readOnly &&
                        <Stack direction="row" spacing={1} marginBottom={2} sx={{ cursor: 'pointer'}} onClick={() => props.toggleWalletAllowance()} alignItems="flex-start">
                            <Box>
                                {wallet_sharing.is_enabled ? <ToggleActiveIcon color={iconColor}/> : <ToggleIcon color={iconColor}/>}
                            </Box>
                            <Typography variant="subtitle1" flex={1} >{t('walletSharingDesc')}</Typography>
                        </Stack>}

                        {readOnly &&
                        <Stack direction="row" spacing={1} marginBottom={2} alignItems="flex-start">
                            <Box>
                                {wallet_sharing.is_enabled ?
                                    <Typography variant="subtitle1" flex={1} >{t('walletSharingEnabledDesc')}</Typography> : 
                                    <Typography variant="subtitle1" flex={1} >{t('walletSharingDisabledDesc')}</Typography>}
                            </Box>
                        </Stack>}

                        {wallet_sharing.is_enabled && 
                        <Box>
                            {!readOnly &&
                            <>
                                <Stack direction="row" spacing={1} marginTop={1} sx={{ cursor: !readOnly && 'pointer'}} onClick={() => !readOnly && props.toggleMaximumAmount()} alignItems="flex-start">
                                    <Box>
                                        {showMaximumAmount ? <ToggleActiveIcon color={iconColor}/> : <ToggleIcon color={iconColor}/>}
                                    </Box>
                                    <Typography variant="subtitle1">{t('restrict_maximum_wallet')}</Typography>
                                </Stack>
                                {showMaximumAmount && <Box my={1}>
                                    <Field 
                                        component={NumbericInputCustom}
                                        name="max_amount"
                                        formatType="currency"
                                        isEdit={!readOnly}
                                        validate={validators.required}
                                        defaultValue={wallet_sharing && wallet_sharing.max_amount ? wallet_sharing.max_amount : null}
                                    />
                                </Box>}

                                <Stack direction="row" spacing={1} marginTop={1} sx={{ cursor: !readOnly && 'pointer'}} onClick={() => !readOnly && props.toggleCommercePools()} alignItems="flex-start">
                                    <Box>
                                        {showCommercePools && commercePools && commercePools.length > 0 ? <ToggleActiveIcon color={iconColor}/> : <ToggleIcon color={iconColor}/>}
                                    </Box>
                                    <Typography variant="subtitle1" style={{opacity: commercePools.length === 0 ? 0.5 : 1}}>{t('restrict_transfer_request_based_on')}</Typography>
                                </Stack>

                                {showCommercePools && commercePools && commercePools.length > 0 && <Box my={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-multiple-name-label" sx={{
                                        color: "grey",
                                        "&.Mui-focused": {
                                            color: palette.primary.main,
                                        },
                                        }}>{t('select_restriction')}
                                    </InputLabel>
                                    <Select
                                        labelId="demo-multiple-name-label"
                                        id="commercePools"
                                        name="commercePools"
                                        input={<OutlinedInput label={t('select_restriction')}/>}
                                        multiple={true}
                                        disabled={readOnly}                                        
                                        onChange={(e) => props.onChangeCommercePools(e.target.value)}
                                        defaultValue={props.commerce_pools && props.commerce_pools.length > 0 ? props.commerce_pools : []}
                                        displayEmpty
                                    >
                                        {commercePools.map((item, index) => {
                                            return (
                                                <MenuItem key={index} sx={{
                                                    cursor: 'pointer',
                                                    ':hover': {
                                                        background: alpha(palette.primary.light, 0.11),
                                                    }
                                                }} value={item.id}>
                                                    <Typography variant="subtitle2" component={'span'}>{item.name}</Typography>
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                
                                </Box>}
                                <Typography variant="subtitle2" mb={2} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('remaining_wallet_allowance')}: {currency}{wallet_sharing && wallet_sharing.remaining_amount ? formatAmount(wallet_sharing.remaining_amount) : '0.00'}</Typography>
                            </>}

                            {readOnly &&
                            <>
                                <Stack direction="row" spacing={1} marginTop={1} alignItems="flex-start">
                                    <Box>
                                        {showMaximumAmount && <Typography variant="subtitle2">{replaceParamTranslation(t('view_restrict_maximum_wallet'), [wallet_sharing.max_amount ])}</Typography>}
                                    </Box>
                                </Stack>
                                {commercePools && commercePools.length > 0 &&
                                    <Stack direction={'row'} alignItems='center' spacing={1} marginTop={1} marginBottom={1}>
                                        <Stack flex={1}>
                                        <Typography variant="subtitle2">{t('view_restrict_transfer_request_based_on')}</Typography>
                                        <Typography>{_commercePools}</Typography>
                                        
                                        </Stack>
                                    </Stack>
                                }
                                <Typography variant="subtitle2" mb={2} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('remaining_wallet_allowance')}: {currency}{wallet_sharing && wallet_sharing.remaining_amount ? formatAmount(wallet_sharing.remaining_amount) : '0.00'}</Typography>
                            </>}
                        </Box>
                        }
                    </Box>

                    <Box mt={1} paddingX={2} mb={1} width={'100%'} borderRadius={2} border={'1px solid'} borderColor={palette.border.main}>
                        <Typography variant="body1" fontWeight={'bold'} marginTop={2} marginBottom={1} display='flex' justifyContent={'center'}>{t('access_level')}</Typography>
                        <Stack marginBottom={2}>
                            <Field
                                name="access_level"
                                component={SelectCustom}
                                isEdit={!readOnly}
                                selectData={accessLevel}
                                keyName={'value'}
                                keyLabel={'label'}
                                valueSelect={defaultValues.access_level && defaultValues.access_level.value ? defaultValues.access_level.value : accessLevel[0].value}
                                onSelectedChange={(e) => props.onChange('access_level', e.target.value, 'value')}
                            />
                        </Stack>

                        {defaultValues.access_level.value === 'RESTRICTED_ACCESS' && <>
                            <Stack direction={'row'} alignContent={'center'} spacing={2}
                                sx={{ cursor: 'pointer' }}
                                onClick={() => !readOnly && props.onChange('restricted_access', {
                                    ...defaultValues.restricted_access,
                                    contact_management: !defaultValues.restricted_access.contact_management
                                })
                                }>
                                <Stack>
                                    <Box>
                                        {defaultValues.restricted_access.contact_management ? <ToggleActiveIcon color={iconColor}/> : <ToggleIcon color={iconColor}/>}
                                    </Box>
                                </Stack>
                                <Stack flex={1}>
                                    <Typography variant='subtitle1'>{t('contact_management')}</Typography>
                                    <Typography variant='subtitle2' mb={1} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('contact_management_desc')}</Typography>
                                </Stack>
                            </Stack>

                            <Stack direction={'row'} alignContent={'center'} spacing={2}
                                sx={{ cursor: 'pointer' }}
                                onClick={() => !readOnly && props.onChange('restricted_access', {
                                    ...defaultValues.restricted_access,
                                    service_requests_management: !defaultValues.restricted_access.service_requests_management
                                })
                                }>
                                <Stack>
                                    <Box>
                                        {defaultValues.restricted_access.service_requests_management ? <ToggleActiveIcon color={iconColor}/> : <ToggleIcon color={iconColor}/>}
                                    </Box>
                                </Stack>
                                <Stack flex={1}>
                                    <Typography  variant='subtitle1'>{t('service_requests_management')}</Typography>
                                    <Typography variant='subtitle2' mb={1} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('service_requests_management_desc')}</Typography>
                                </Stack>
                            </Stack>

                            <Stack direction={'row'} alignContent={'center'} spacing={2}
                                sx={{ cursor: 'pointer' }}
                                onClick={() => !readOnly && props.onChange('restricted_access',
                                    {
                                        ...defaultValues.restricted_access,
                                        orders_management: !defaultValues.restricted_access.orders_management
                                    })
                                }>
                                <Stack>
                                    <Box>
                                        {defaultValues.restricted_access.orders_management ? <ToggleActiveIcon color={iconColor}/> : <ToggleIcon color={iconColor}/>}
                                    </Box>
                                </Stack>
                                <Stack flex={1}>
                                    <Typography  variant='subtitle1'>{t('orders_management')}</Typography>
                                    <Typography variant='subtitle2' mb={2} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('orders_management_desc')}</Typography>
                                </Stack>
                            </Stack>
                        </>}
                    </Box>

                    {!readOnly &&
                        <Stack direction="row" alignItems="center" justifyContent="center">
                            <Button fullWidth variant="outlined" id="leaveCommunity/Submit" borderRadius={'50%'}
                                onClick={handleSubmit}>
                                {t('btn_submit')}
                            </Button>
                        </Stack>
                        }
                </Box>
            )}
            />
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
        </>

    )
}